export const upload = {
    data() {
        return {
           ysyMIsDeletedOssFile: false 
        }
    },
    methods: {
        // 上传-删除
        ysyMDelAliOssFile(path) {
            this.$axios.get('api/api3_admin_del_ali_oss', {
                params: {
                    path
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMIsDeletedOssFile = true
                }
            }).catch()
        },
    }
}


//////////////////
// WEBPACK FOOTER
// ./static/mixins/upload.js
// module id = null
// module chunks = 